import React from 'react';

const FA_LABELS = {
  UFA: 'Unrestricted Free Agent',
  RFA: 'Restricted Free Agent',
};

const SIZES = {
  small: 'fa-status-badge fa-status-badge-sm',
  normal: 'fa-status-badge',
  large: 'fa-status-badge fa-status-badge-lg',
};

export default function FaStatusBadge({ status, size = 'normal' }) {
  if (status !== 'UFA' && status !== 'RFA') return null;

  return (
    <span
      className={`${SIZES[size] || SIZES.normal} fa-status-${status.toLowerCase()}`}
      title={FA_LABELS[status]}
    >
      {status}
    </span>
  );
}
